<!-- Avatar icon representing the AI agent in chat, showing the Healed signet. -->

<script lang="ts" setup>
import Signet from '@sigma/assets/healed-logo-picture-mark-w.svg?component';

import AvatarIcon from '../AvatarIcon.vue';
</script>

<template>
  <AvatarIcon>
    <Signet />
  </AvatarIcon>
</template>
